import { render, staticRenderFns } from "./HematitCombinedParts.vue?vue&type=template&id=7c80aa56&scoped=true"
import script from "./HematitCombinedParts.vue?vue&type=script&lang=js"
export * from "./HematitCombinedParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80aa56",
  null
  
)

export default component.exports